/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';

import { ErrorTypes } from '../error';
import { JumpChannelError } from '../error/JumpChannelError';
import { Locale, LocaleKeys } from '../locale';
import { Log } from '../logging';
import { BrandingUiUtility } from '../utils';
import { ErrorCodeUtil } from '../utils/ErrorCodeUtil';
import { IErrorAdapter } from './adapters';

export class JumpChannelErrorMapper {
    private static TAG: string = 'JumpChannelErrorMapper';

    private code: string;

    private description: string;

    private message: string;

    private title: string;

    private type: string;

    private adapter: IErrorAdapter;

    public constructor(adapter: IErrorAdapter) {
        this.code = '';
        this.description = '';
        this.message = '';
        this.title = '';
        this.type = '';
        this.adapter = adapter;
    }

    private setGeneralErrorProperties(errorCode: string, actualError?: any) {
        switch (errorCode) {
            case ErrorTypes.JUMP_CHANNEL_UNAVAILABLE_V347: {
                this.title = Locale.getString(LocaleKeys.JUMP_CHANNEL_ERROR_OVERLAY_TITLE);

                // Extract subcode once and reuse for both code and description
                const subcode = actualError
                    ? ErrorCodeUtil.extractSubErrorCode(actualError, this.adapter)
                    : '';

                this.code = subcode ? `${errorCode}-${subcode}` : errorCode;

                this.description = BrandingUiUtility.formatDescription(
                    Locale.getString(LocaleKeys.JUMP_CHANNEL_ERROR_OVERLAY_DESCRIPTION),
                    {
                        ERROR_CODE: errorCode,
                        SUBCODE: subcode,
                    },
                );
                this.type = 'JUMP_CHANNEL_UNAVAILABLE';
                break;
            }
            default:
                this.title = Locale.getString(LocaleKeys.JUMP_CHANNEL_ERROR_OVERLAY_TITLE);
                this.description = BrandingUiUtility.formatDescription(
                    Locale.getString(LocaleKeys.JUMP_CHANNEL_ERROR_OVERLAY_DESCRIPTION),
                    {
                        ERROR_CODE: errorCode,
                        SUBCODE: '',
                    },
                );
                this.code = errorCode;
                this.type = 'JUMP_CHANNEL_UNKNOWN_ERROR';
                break;
        }
    }

    public getErrorByCode(errorCode: string, actualError?: any): JumpChannelError {
        this.setGeneralErrorProperties(errorCode, actualError);
        const error = new JumpChannelError(
            this.code,
            this.message,
            this.description,
            this.title,
            this.type,
        );
        Log.e(JumpChannelErrorMapper.TAG, 'error during jump channel operation', error);
        Diagnostics.error(JumpChannelErrorMapper.TAG, 'error during jump channel operation', error);
        return error;
    }
}
